export default __webpack_public_path__ + "static/media/office4.97b2a05d.jpg";